// GA4 is loaded by components/global/Analytics.js only after the visitor
// accepts statistics cookies, so without consent there is no gtag and
// events are simply not sent.
export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return
  window.gtag("event", name, params)
}

// "en-GB" / "pl-PL" on <html> (set during SSR) -> "EN" / "PL"
export const pageLanguage = () =>
  (document.documentElement.lang || "en").slice(0, 2).toUpperCase()

// Phone numbers in WP are typed by hand ("+48 791 713 250", "tel. +48 ...").
export const telHref = phone => `tel:${String(phone).replace(/[^\d+]/g, "")}`

export const mailtoHref = email => `mailto:${String(email).trim()}`

// One delegated listener covers every tel:/mailto: link, including links
// inside WordPress content.
export const trackContactClicks = () => {
  document.addEventListener("click", event => {
    const link = event.target.closest?.('a[href^="tel:"], a[href^="mailto:"]')
    if (!link) return

    const href = link.getAttribute("href")
    const isPhone = href.startsWith("tel:")

    trackEvent(isPhone ? "click_phone" : "click_email", {
      contact_value: decodeURIComponent(href.replace(/^(tel|mailto):/, "").split("?")[0]),
      page_language: pageLanguage(),
      page_path: window.location.pathname,
    })
  })
}
